import React from 'react';
import { AuthContext } from "../../AuthContext";
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { Dropdown } from 'react-bootstrap';
import ImgRed from '../../images/red-bullet.gif';
import ImgOrange from '../../images/orange-bullet.gif';
import ImgGreen from '../../images/green-bullet.gif';
import ImgEQ from "../../images/EQ_Blue.png";
import ImgFL from "../../images/FL_Blue.png";
import ImgNL from "../../images/NL_Blue.png";
import ImgT2 from "../../images/T2_Blue.png";
import ImgTC from "../../images/TC_Blue.png";
import { getAPI } from '../GdacsAPI';

const EditingServiceRow = (props) => {
    const [value, setValue] = React.useState(props.service.id);
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const [alertLevel, setAlertLevel] = React.useState(props.service.idServiceType === 1 && props.service.eventType === "NL" ? ["Green"] : props.service.idServiceType === 1 ? ["Red", "Orange", "Green"] : props.service.idServiceType === 3 ? ["Red", "Orange"] : ["Red", "Orange", "Green"]);
    const [language, setLanguage] = React.useState([]);
    const [alertsBycode, setAlertsBycode] = React.useState([])
    const [state, setState] = React.useState();
    const [regions, setRegions] = React.useState([]);
    const [eventtypes, setEventTypes] = React.useState([]);
    const authContext = React.useContext(AuthContext);
    const [service, setService] = React.useState(props.service);
    const [toggleContents, setToggleContents] = React.useState();
    const [toggleEvents, setToggleEvents] = React.useState();
    const [toggleAlerts, setToggleAlerts] = React.useState();
    const [toggleRegions, setToggleRegions] = React.useState();
    const [toggleLanguages, setToggleLanguages] = React.useState();
    const [serviceDisabled, setServiceDisabled] = React.useState(props.service.eventType === "NL" ? true : false);
    const [alertDisabled, setAlertDisabled] = React.useState(props.service.eventType === "NL" ? true : false);
    const [regionDisabled, setRegionDisabled] = React.useState(props.service.eventType === "NL" ? true : false);
    const [languageDisabled, setLanguageDisabled] = React.useState(props.service.eventType === "NL" ? true : false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState("");

    React.useEffect(() => {
        props.isButtonDisabled(isButtonDisabled);
        props.responseMessage(responseMessage);
        props.isModified(isModified);
    }, [])

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        const obj = [...servicesTypesData];
        let servicesFiltered = [];

        if (props.service.eventType === "T2") {
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].idServiceType === 1 || obj[i].idServiceType === 10) {
                    let servtype = obj.find((item) => (item.idServiceType === obj[i].idServiceType));
                    servicesFiltered.push(servtype);
                }
            }
        }

        if (props.service.eventType === "T2") {
            setServicesTypes(servicesFiltered);
            setServicesTypesDevice(servicesFiltered);
            setLanguage(servicesTypesData[1].listLanguages);
        }
        else {
            setServicesTypes(servicesTypesData);
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[1].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }

    async function GetAlertsByChannel(idservicetype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByIdservice?idService=` + idservicetype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();

        let lang = servicestypesdevice.filter(x => x.idServiceType === idservicetype);

        if (servicesAlerts) {
            setAlertLevel(servicesAlerts[0].listAlertlevels);
            setToggleAlerts(icons[servicesAlerts[0].listAlertlevels]);
            setLanguage(lang[0].listLanguages);
            setToggleLanguages(lang[0].listLanguages[0].value);
        }
    }

    async function GetAlerts(eventtype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByCode?code=` + eventtype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();
        const obj = [...servicesAlerts];

        let p = obj.filter(a => a.eventtypecode === eventtype);

        const filter = [...servicestypesdevice];
        /*        setServicesTypes([]);*/

        let a = [];

        for (var i = 0; i < p.length; i++) {

            const idtype = p[i].idservicetype;
            if (idtype === 1 || idtype === 3) {
                let servtype = filter.find((item) => (item.idServiceType === idtype));

                a.push(servtype);
            }
        }

        if (servicesAlerts) {
            setAlertsBycode(servicesAlerts);
            setServicesTypes(a);
            setToggleContents(icons[a[0].idServiceType]);
            setAlertLevel(p[0].listAlertlevels);
            setToggleAlerts(icons[p[0].listAlertlevels[0]]);
            setLanguage(a[0].listLanguages);
            setToggleLanguages(a[0].listLanguages[0].value);
            if (eventtype === "NL")
                setToggleRegions(regions[0].key);
        }
    }

    React.useEffect(() => {
        GetServicesTypes();
        GetRegions();
        GetEventTypes();
    }, []);

    const handleChangeEvent = (e) => {
        setService((a) => ({ ...a, eventType: e }));
        if (e === "NL") {
            setServiceDisabled(true);
            setAlertDisabled(true);
            setRegionDisabled(true);
            setLanguageDisabled(true);
        }
        else {
            setServiceDisabled(false);
            setAlertDisabled(false);
            setRegionDisabled(false);
            setLanguageDisabled(false);
        }
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeService = (e) => {
        setService((a) => ({ ...a, idServiceType: parseInt(e) }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeAlertLevel = (e) => {
        setService((a) => ({ ...a, alertLevel: e }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeRegion = (e) => {
        setService((a) => ({ ...a, region: parseInt(e) }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeLanguage = (e) => {
        setService((a) => ({ ...a, language: e }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeCheckNight = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, stopNight: newValue }));
        props.responseMessage("");
        props.isModified(true);
    };

    const handleChangeCheckEnabled = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, enabled: newValue }));
        props.responseMessage("");
        props.isModified(true);
    };

    React.useEffect(() => {
        if (servicestypes.length > 0) {
            const newValue = parseInt(service.idServiceType);
            setService((a) => ({ ...a, idServiceType: newValue }));
        }
    }, [servicestypes]);

    React.useEffect(() => {
        if (service.eventtype === undefined && eventtypes.length > 0)
            setService((a) => ({ ...a, eventType: service.eventType }));
    }, [eventtypes]);

    React.useEffect(() => {
        if (regions.length > 0) {
            const newValue = parseInt(service.region);
            setService((a) => ({ ...a, region: newValue }));
        }
    }, [regions]);

    React.useEffect(() => {
        if (language.length > 0) {
            const newValue = service.language;
            setService((a) => ({ ...a, language: newValue }));
        }
    }, [language]);

    React.useEffect(() => {
        if (alertLevel.length > 0) {
            const newValue = alertLevel[0];
            setService((a) => ({ ...a, alertLevel: newValue }));
        }
        else {
            const newValue = "Red";
            setService((a) => ({ ...a, alertLevel: newValue }));
        }
    }, [alertLevel]);

    const icons = {
        "1": <EnvelopeFill color="#0099CC" size={18} />,
        "3": <Telephone color="#0099CC" size={18} />,
        "10": <Phone color="#0099CC" size={18} />,
        "Red": <img src={ImgRed} />,
        "Orange": <img src={ImgOrange} />,
        "Green": <img src={ImgGreen} />,
        "EQ": <img src={ImgEQ} className="icon_table" />,
        "FL": <img src={ImgFL} className="icon_table" />,
        "NL": <img src={ImgNL} className="icon_table" />,
        "T2": <img src={ImgT2} className="icon_table" />,
        "TC": <img src={ImgTC} className="icon_table" />,
    };

    return (
        <tr>
            <td className="cell_hidden">{props.service.id}</td>
            <td className="cell_hidden">{props.service.idService}</td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleEvents(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" >
                        {!toggleEvents ? eventtypes.filter(item => item.eventtype === props.service.eventType).map(types => (
                            <img src={`Images/${types.eventtype}_Blue.png`} className="icon_table" />
                        )) : toggleEvents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu onSelect={handleChangeService} value={service.eventtype} >
                        {
                            eventtypes.map((item) => {
                                return (<Dropdown.Item value={item.eventtype} key={item.eventtype} eventKey={item.eventtype} onClick={e => GetAlerts(item.eventtype)} onSelect={handleChangeEvent} >
                                    <img src={`Images/${item.eventtype}_Blue.png`} className="icon_table" /> - {item.description}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td className="cell_alerts" style={{ textAlign: "center" }}>
                <Dropdown onSelect={eventKey => {
                    setToggleContents(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={serviceDisabled} >
                        {!toggleContents ? servicestypes.filter(item => item.idServiceType === props.service.idServiceType).map(types => (
                            types.idServiceType === 1 ?
                                <EnvelopeFill color="#0099CC" size={18} />
                                : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                                    : <Phone color="#0099CC" size={18} />
                        )) : toggleContents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {
                            servicestypes.map((item) => {
                                return (<Dropdown.Item value={item.idServiceType} key={item.idServiceType} eventKey={item.idServiceType} onClick={e => GetAlertsByChannel(item.idServiceType)} onSelect={handleChangeService} >
                                    {item.idServiceType === 1 ?
                                        <><EnvelopeFill color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                        : item.idServiceType === 3 ? <><Telephone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                            : <><Phone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                    }
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleAlerts(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={alertDisabled} >
                        {!toggleAlerts ? <img src={`Images/${service.alertLevel}-bullet.gif`} /> : toggleAlerts}
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                        {
                            alertLevel.map((item, index) => {
                                return (<Dropdown.Item id={item} value={item} key={index} eventKey={item} onSelect={handleChangeAlertLevel} >
                                    <img src={`Images/${item}-bullet.gif`} /> - {item}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleRegions(<>
                        {regions.filter(item => item.idRegion === parseInt(eventKey)).map(types => (
                            <>
                                {types.regionName}
                            </>
                        ))}
                    </>);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={regionDisabled} >
                        {!toggleRegions ? regions.filter(item => item.idRegion === props.service.region).map(types => (
                            <>
                                {types.regionName}
                            </>
                        )) : toggleRegions}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={service.region}>
                        {
                            regions.map((item) => {
                                return (<Dropdown.Item value={item.idRegion} key={item.idRegion} eventKey={item.idRegion} onSelect={handleChangeRegion} >
                                    {item.regionName}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleLanguages(<>
                        {language.filter(item => item.key === eventKey).map(types => (
                            <>
                                {types.value}
                            </>
                        ))}
                    </>);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={languageDisabled}>
                        {!toggleLanguages ? language.filter(item => item.key === props.service.language).map(types => (
                            <>
                                {types.value}
                            </>
                        )) : toggleLanguages}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={service.language}>
                        {
                            language.map((item) => {
                                return (<Dropdown.Item value={item.key} key={item.key} eventKey={item.key} onSelect={handleChangeLanguage} >
                                    {item.value}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td><input name="stopNight" className="input-checkbox" defaultChecked={props.service.stopNight} type="checkbox" onChange={handleChangeCheckNight} /></td>
            <td><input name="enabled" className="input-checkbox" defaultChecked={props.service.enabled} type='checkbox' onChange={handleChangeCheckEnabled} /></td>
            <td>
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "red" }} onClick={() => props.onRequestSaveService(service)}><FaIcons.FaRegSave style={{ height: '20px' }} /></button> &nbsp;
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "#ed7d31" }} onClick={() => props.onRequestDismissEdit(props.service.id)}><FaIcons.FaArrowLeft style={{ height: '20px' }} /></button>
            </td>
        </tr>
    )
}

export { EditingServiceRow };